import { FrameService } from '@aipb/frame/data-access';
import { inject, Injectable } from '@angular/core';
import { SetupHandler } from './setup.handler';
import { CONFIG_APPLICATIONS } from '@aipb/util/di';

@Injectable({
  providedIn: 'root'
})
export class FrameHandler extends SetupHandler {
  private frame = inject(FrameService);
  private applications = inject(CONFIG_APPLICATIONS);

  constructor() {
    super('frame.handler');
  }

  handle() {
    this.frame.init(this.applications);
    this.addLogMessage(`init applications ${Object.keys(this.applications).join(', ')}`);
  }
}
